/* eslint-disable */
export default {
  noResultFoundFor: 'No se encontraron resultados para',
  search: 'Buscar',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
